var React = require('react');

function ClockIconBlack (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7","cy":"7","r":"7","fill":"#333333","key":0}),React.createElement("path",{"d":"M6 3H7V7.44262L10 9.19344L9.5 10L6 7.93443L6 3Z","fill":"white","stroke":"white","strokeWidth":"0.5","key":1})]);
}

ClockIconBlack.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = ClockIconBlack;

ClockIconBlack.default = ClockIconBlack;
